export default {
    products(state, payload) {
        for (let key in payload) {
            payload[key].count = 0;
        }
        state.products = payload;
    },

    addToCart(state, payload) {
        let indexInCart = false;

        state.cartError = false;
        let cartCount = 0;
        state.cart.forEach(item => {
            cartCount += parseInt(item.count);
        });
        console.log(cartCount);

        cartCount = parseInt(cartCount) + parseInt(state.products[payload.index].count);
        console.log(cartCount);
        if (cartCount > 50) {
            state.cartError = true;
            return;
        }

        state.cart.forEach((item, index) => {
            if (item.id == state.products[payload.index].id) {
                indexInCart = index;
            }
        });

        if (indexInCart !== false) {
            state.cart[indexInCart].count = parseInt(state.cart[indexInCart].count) + parseInt(state.products[payload.index].count);
        } else {
            state.cart.push({ ...state.products[payload.index] });
        }
        state.products[payload.index].count = 0;
    },

    updateSelectedItemsCount(state, payload) {
        state.products[payload.index].count = payload.count;
    },

    updateCountById(state, payload) {
        let productIndex = false;

        state.products.forEach((item, index) => {
            if (payload.index == item.id) {
                productIndex = index;
            }
        });

        if (productIndex !== false) {
            state.cart.push({ ...state.products[productIndex], count: payload.count });
        }
    },

    updateSelectedItemsCountInCart(state, payload) {
        state.cart[payload.index].count = payload.count;
        if (state.cart[payload.index].count == 0) {
            setTimeout(() => {
                state.cart.splice(payload.index, 1);
            }, 1000)
        }
    },

    deleteFromCart(state, payload) {
        state.cart.splice(payload.index, 1);
    },

    buyerData(state, payload) {
        state.buyerData = payload;
    },

    deliveryToOtherAddress(state, payload) {
        state.deliveryToOtherAddress = payload;
    },

    deliveryToPhoneAndEmail(state, payload) {
        state.deliveryToPhoneAndEmail = payload;
    },

    deliveryAddress(state, payload) {
        state.deliveryAddress = payload;
    },

    paymentType(state, payload) {
        state.paymentType = payload;
    },

    buyerDataErrors(state, payload) {
        state.buyerDataErrors = payload
    },

    deliveryDataErrors(state, payload) {
        state.deliveryDataErrors = payload
    },

    prisonerData(state, payload) {
        state.prisonerData = payload;
    },

    prisonerDataErrors(state, payload) {
        state.prisonerDataErrors = payload;
    },

    deliveryToPrison(state, payload) {
        state.deliveryToPrison = payload;
    },

    location(state, payload) {
        state.location = payload;
    },

    locations(state, payload) {
        state.locations = payload;
    },

    order(state, payload) {
        state.order = payload;
    },

    updateDeliveryToOtherEmailAndPhone(state, payload) {
        state.deliveryToOtherEmailAndPhone = payload;
    },

    edeliveryDataErrors(state, payload) {
        state.edeliveryDataErrors = payload;
    },

    edeliveryAddress(state, payload) {
        state.edeliveryAddress = payload;
    },

    invoiceDataErrors(state, payload) {
        state.invoiceDataErrors = payload;
    },

    setCurrentOptionsStage(state, payload) {
        state.currentOptionsStage = payload;
    },

    invoiceData(state, payload) {
        state.invoiceData = payload;
    },

    letterOptions(state, payload){
        state.letterOptions = payload;
    }
}